/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/



import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { DataStoreService } from '../../../core/services/datastore.service';
import { Injectable } from '@angular/core';
import { LmsLoaderService } from './../../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
import { LocoTransfer } from '../../../core/model/loco-transfer.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { Observable } from 'rxjs';
import { PopupService } from '../../../core/services/popup.service';
import { Router } from '@angular/router';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';

/**
 * Loco Status Service to get data for locomotives details.
 * @export
 * @class LocoStatusService
 */
@Injectable()
export class LocoStatusService {

    private RESOURCE_URL = '/locomotives/status';
    private configData: any;
    private apiUrl: string;

    /**
     * Creates an instance of LocoStatusService.
     * @param {HttpClient} http
     * @param {ConfigService} configService
     * @param {DataStoreService} dataStoreService
     * @param {LmsLoggerService} lmsLoggerService
     * @memberOf LocoStatusService
     */
    constructor(private http: HttpClient,
        private configService: ConfigService,
        private dataStoreService: DataStoreService,
        private lmsLoggerService: LmsLoggerService,
        private router: Router,
        private lmsLoaderService: LmsLoaderService, private messageHandlerService: MessageHandlerService, private popupService: PopupService,
        private appUtilityService: AppUtilityService,
        private staticDataStoreService: StaticDataStoreService) {
        this.configData = this.configService.getConfigData();
        this.apiUrl = this.configData.urls.API_URL;
    }

    load(locos) {
        this.lmsLoggerService.logInfo('LocoDataService => load()',
            `Loco Status Fetch Successfull for ${JSON.stringify(locos)}`);
    }

    /**
     * Fetching Data from Rest Service Provided or loading data from dataStoreService if the data is already present.
     * @param {Tab} tab
     * @param {boolean} isRefresh
     * @memberOf LocoStatusService
     */
    getData(locos: string) {
        this.lmsLoaderService.showLoader();
        const opr = 'INQU';
        this.lmsLoggerService.logInfo('LocoStatusService=>getData service call starts');
        return this.http.get(
            `${this.configService.getConfigData().urls.API_URL}${this.RESOURCE_URL}?opr=${opr}&id=${locos}`).pipe(
              tap(() => this.lmsLoggerService.logInfo('LocoStatusService=>getData service call ends'))
            );
    }
    /**
     * Loco Transfer Service Call
     * @param {Array<LocoTransfer>} locoTransfer
     * @param {string} operation
     * @returns {Observable<Response>}
     * @memberOf LocoStatusService
     */
    transferLocomotive(locoTransfer: Array<LocoTransfer>, operation: string): Observable<Response> {
        let headers = new HttpHeaders();
        const apiUrl = this.configData.urls.API_URL;
        const windowCode = 'LWLS';
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        this.lmsLoggerService.logInfo('LocoStatusService=>transferLocomotive service call starts');
        return this.http.put<any>(`${apiUrl}/locomotives?opr=${operation}&wc=${windowCode}`,
            JSON.stringify(locoTransfer), options).pipe(
              tap(() => this.lmsLoggerService.logInfo('LocoStatusService=>transferLocomotive service call ends'))
            );
    }

    /**
     * Service request for bre exception.
     * @param {Array<String>} locoList
     * @param {string} trainId
     * @returns {Observable<Response>}
     * @memberOf LocoStatusService
     */
    breTransferRequest(locoList: Array<String>, trainId: string): Observable<Response> {
        const apiUrl = this.configData.urls.API_URL;
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        this.lmsLoggerService.logInfo('LocoStatusService=>breTransferRequest service call starts');
        return this.http.put<any>(`${apiUrl}/trains/${trainId}/breparam?opr=INQU`,
            JSON.stringify(locoList), options).pipe(
              tap(() => this.lmsLoggerService.logInfo('LocoStatusService=>breTransferRequest service call ends'))
            );
    }


    /**
     * @memberOf LocoStatusService
     */
    cleanBehaviourSubject() {

    }
}
